import React, { useEffect, useRef } from 'react';
import renderMathInElement from 'katex/dist/contrib/auto-render';
import katex from 'katex';
import 'katex/dist/katex.min.css';

function MathRenderer({ children }) {
  const containerRef = useRef(null);

  useEffect(() => {
    if (containerRef.current) {

      // const mathElements = containerRef.current.querySelectorAll('.math-tex');
      // mathElements.forEach((element) => {
      //   const texString = element.textContent;
      //   katex.render(texString, element, {
      //     throwOnError: false
      //   });
      // });

      renderMathInElement(containerRef.current, {
        delimiters: [
          { left: '$$', right: '$$', display: true },
          { left: '$', right: '$', display: false },
          { left: '\\(', right: '\\)', display: false },
          { left: '\\[', right: '\\]', display: true }
        ],
        throwOnError: false
      });
    }
  }, [children]); // Re-runs if the content changes dynamically

  return <div ref={containerRef} dangerouslySetInnerHTML={{ __html: children }} />
}

export default MathRenderer;
